import React from 'react'
import { useTranslation } from 'contexts/Localization'
import { BonusesIcon, SafeIcon, TeamIcon } from '@nominex/dex-uikit'
import { FetchStatus } from 'state/types'
import CardItem, { CardItemProps } from './CardItem'

export interface RewardsCardBodyProps {
  cashback: number
  holderBonus: number
  referralRewards: number
  fetchStatus: FetchStatus
}

const RewardsCardBody: React.FC<RewardsCardBodyProps> = ({
  fetchStatus: rewardsFetchStatus,
  cashback,
  holderBonus,
  referralRewards,
}) => {
  const { t } = useTranslation()

  const cardItems: CardItemProps[] = [
    {
      label: t('Trading cashback'),
      title: t('Unclaimed cashback'),
      value: cashback,
      fetchStatus: rewardsFetchStatus,
      icon: <BonusesIcon width="16px" height="16px" />,
      background: 'gradient-dark-blue',
    },
    {
      label: t('Holder Rewards'),
      title: t('Unclaimed holder rewards'),
      value: holderBonus,
      fetchStatus: rewardsFetchStatus,
      icon: <SafeIcon width="16px" height="16px" />,
      background: 'gradient-green',
    },
    {
      label: t('Referral program Rewards'),
      title: t('Unclaimed referral rewards'),
      value: referralRewards,
      fetchStatus: rewardsFetchStatus,
      icon: <TeamIcon width="16px" height="16px" />,
      background: 'gradient-violet',
    },
  ]

  return (
    <div className="flex flex-col gap-12 w-[100%]">
      {cardItems.map(({ icon, background, value, label, title, fetchStatus }) => (
        <CardItem
          icon={icon}
          background={background}
          value={value}
          label={label}
          title={title}
          fetchStatus={fetchStatus}
          key={label.replace(' ', '').toLowerCase()}
        />
      ))}
    </div>
  )
}

export default RewardsCardBody
